import { render } from "./CmpPlantillasWhatsapp.vue?vue&type=template&id=4788f187&scoped=true"
import script from "./CmpPlantillasWhatsapp.vue?vue&type=script&lang=js"
export * from "./CmpPlantillasWhatsapp.vue?vue&type=script&lang=js"

import "./CmpPlantillasWhatsapp.vue?vue&type=style&index=0&id=4788f187&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4788f187"]])

export default __exports__